import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { attachmentMaster } from 'src/app/Models/BasicForms/attachmentMaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-attachment-drawer',
  templateUrl: './attachment-drawer.component.html',
  styleUrls: ['./attachment-drawer.component.css'],
  providers: [DatePipe]
})

export class AttachmentDrawerComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: attachmentMaster;
  @Input() typeData: number;
  @Input() typeIDData: number;

  constructor(public _apiService: ApiService, private notificationService: NzNotificationService, private datePipe: DatePipe) { }

  ngOnInit(): void { }

  isSpinning = false;
  logtext: string = "";
  uploadedAttachmentStr: string;

  save(addNew: boolean): void {
    var isOk = true;

    if (!this.data.ID) {
      if (this.fileURL) {
        var number = Math.floor(100000 + Math.random() * 900000);
        var fileExt = this.fileURL.name.split('.').pop();
        var url = "Att_" + number + "." + fileExt;
        this.data.ATTACHMENT_URL = "";

        this._apiService.onUpload(this.folderName, this.fileURL, url).subscribe(res => {
          if (res["code"] == 200) {


          } else {

          }
        });

        // this.uploadedAttachmentStr = this._apiService.retriveimgUrl + this.folderName + "/" + url;
        this.uploadedAttachmentStr = url;
      }

      else {
        isOk = false;
        this.notificationService.error("Please Select Valid Attachment", "");
      }

    } else {
      if (!this.fileURL) {
        this.uploadedAttachmentStr = this.data.ATTACHMENT_URL;

      } else {
        var number = Math.floor(100000 + Math.random() * 900000);
        var fileExt = this.fileURL.name.split('.').pop();
        var url = "Att_" + number + "." + fileExt;
        this.data.ATTACHMENT_URL = "";

        this._apiService.onUpload(this.folderName, this.fileURL, url).subscribe(res => {
          if (res["code"] == 200) {


          } else {

          }
        });

        // this.uploadedAttachmentStr = this._apiService.retriveimgUrl + this.folderName + "/" + url;
        this.uploadedAttachmentStr = url;
      }
    }

    if (isOk) {
      this.isSpinning = true;

      this.data.UPDATED_DATETIME = new Date();
      this.data.UPDATED_DATETIME = this.datePipe.transform(this.data.UPDATED_DATETIME, "yyyy-MM-dd HH:mm") + ":00";
      this.data.USER_ID = this._apiService.userId;
      this.data.TYPE = this.typeData;
      this.data.TYPE_ID = this.typeIDData;
      this.data.ATTACHMENT_URL = this.uploadedAttachmentStr;
      this.data.IS_ACTIVE = true;



      if (!this.data.ID) {
        this._apiService.createAttachment(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Attachment Added Successfully", "");

            if (!addNew) {
              this.drawerClose();
              this.fileURL = null;

              this.logtext = 'Save & Close - Attachment Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Attachment Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });

            } else {
              this.data = new attachmentMaster();
              this.fileURL = null;

              this.logtext = 'Save & New - Attachment Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Attachment Master ]";
              this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
                if (successCode['code'] == "200") {

                }
                else {

                }
              });
            }
            this.isSpinning = false;

          } else {
            this.notificationService.error("Failed to Add Attachment", "");
            this.logtext = 'Save & Close - Attachment Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Attachment Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }
        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });

      } else {
        this._apiService.updateAttachment(this.data).subscribe(successCode => {


          if (successCode['code'] == "200") {
            this.notificationService.success("Attachment Updated Successfully", "");
            this.logtext = 'Update & Close - Attachment Master form - SUCCESS - ' + JSON.stringify(this.data) + " KEYWORD [C - Attachment Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });

            this.isSpinning = false;
            this.drawerClose();
            this.fileURL = null;

          } else {
            this.notificationService.error("Failed to Update Attachment", "");
            this.logtext = 'Update & Close - Attachment Master form - ERROR - ' + JSON.stringify(this.data) + " KEYWORD [C - Attachment Master ]";
            this._apiService.addLog('A', this.logtext, this._apiService.emailId).subscribe(successCode => {
              if (successCode['code'] == "200") {

              }
              else {

              }
            });
          }

        }, err => {


          if (err["ok"] == false) {
            this.notificationService.error("Server Not Found", "");
          }
        });
      }
    }
  }

  folderName = "Attachments"
  date = new Date();
  date1 = this.datePipe.transform(this.date, 'yyyyMMddHHmmss')

  close(attachmentPage: NgForm) {
    this.drawerClose();
    this.resetDrawer(attachmentPage);
  }

  resetDrawer(attachmentPage: NgForm) {
    this.isSpinning = false;
    attachmentPage.form.reset();
    this.data = new attachmentMaster();
  }

  // typeWiseList= [];
  // onTypeChange(selectedType) {
  //   this.data.TYPE_ID= 0;

  //   if(selectedType== 1){
  //     this.typeWiseList= [
  //       {NAME: "Project 1", TYPE_ID: 1},
  //       {NAME: "Project 2", TYPE_ID: 2},
  //       {NAME: "Project 3", TYPE_ID: 3}]
  //   } 

  //   else if(selectedType== 2) {
  //     this.typeWiseList= [
  //       {NAME: "Module 1", TYPE_ID: 1},
  //       {NAME: "Module 2", TYPE_ID: 2},
  //       {NAME: "Module 3", TYPE_ID: 3}]
  //   } 

  //   else if(selectedType== 3) {
  //     this.typeWiseList= [
  //       {NAME: "Feature 1", TYPE_ID: 1},
  //       {NAME: "Feature 2", TYPE_ID: 2},
  //       {NAME: "Feature 3", TYPE_ID: 3}]
  //   } 

  //   else if(selectedType== 4) {
  //     this.typeWiseList= [
  //       {NAME: "Task 1", TYPE_ID: 1},
  //       {NAME: "Task 2", TYPE_ID: 2},
  //       {NAME: "Task 3", TYPE_ID: 3}]
  //   }
  // }

  fileURL: File = null;
  onFileSelected(event) {
    this.fileURL = <File>event.target.files[0];
  }

  clear() {
    this.fileURL = null;
  }
}
